<template>
  <div class="xcai-chat-layout w-full h-full">
    <header
      class="chatbot-navhead flex items-center fixed left-0 top-0 right-0 z-50"
      :style="{
        height: `${chatNavHeadHeight}px`,
        borderBottom: '0.01em solid #ebedee',
      }"
    >
      <ChatHeadBar />
    </header>
    <main
      class="chatbot-main flex flex-col max-h-full overflow-hidden"
      :style="{
        marginTop: `${chatNavHeadHeight}px`,
        height: `calc(100% - ${chatNavHeadHeight}px)`,
      }"
    >
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.fullPath" />
      </router-view>
    </main>
  </div>
</template>

<script setup lang="ts">
import ChatHeadBar from './ChatHeadBar.vue'
import { useTheme } from '@/hooks'

const { chatNavHeadHeight } = useTheme()
</script>

<style scoped lang="less">
.xcai-chat-layout {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-image: linear-gradient(120deg, #fdfbfb 0%, #e3e9ec 100%);

  header.chatbot-navhead {
    flex: 0 0 50px;
  }

  main.chatbot-main {
    flex: 1 1 auto;

    div {
      height: 100%;
      background-image: linear-gradient(
        75deg,
        #fdfbfb 0%,
        #f2f4f6 30%,
        #fdfbfb 100%
      );
    }
  }
}
</style>
